var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container seg-content general user" }, [
      _c("section", { staticClass: "home-list" }, [
        _c("div", { staticClass: "hl-wid ww4 watch-filter" }, [
          _c("h4", [_vm._v("Total watch stats")]),
          _vm._v(" "),
          _c("form", { staticClass: "user-form filter" }, [
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("Date from:")]),
                _vm._v(" "),
                _c("datepicker", {
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.dateStart,
                    callback: function($$v) {
                      _vm.dateStart = $$v
                    },
                    expression: "dateStart"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("Date to:")]),
                _vm._v(" "),
                _c("datepicker", {
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.dateEnd,
                    callback: function($$v) {
                      _vm.dateEnd = $$v
                    },
                    expression: "dateEnd"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("User")]),
                _vm._v(" "),
                _c("keyval-select", {
                  attrs: { options: _vm.users },
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.userId,
                    callback: function($$v) {
                      _vm.userId = $$v
                    },
                    expression: "userId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("Video")]),
                _vm._v(" "),
                _c("keyval-select", {
                  attrs: { options: _vm.videos },
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.videoId,
                    callback: function($$v) {
                      _vm.videoId = $$v
                    },
                    expression: "videoId"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hl-wid ww4 watch-totals" }, [
          _c("h4", [_vm._v("Per date")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.dates, function(date) {
              return _c("li", [
                _c("span", { staticClass: "date" }, [
                  _vm._v(_vm._s(date.label))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(date.count) + " views")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "duration" }, [
                  _vm._v(_vm._s(_vm.formatDuration(date.duration)))
                ])
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        !(this.userId * 1)
          ? _c("div", { staticClass: "hl-wid ww4 watch-totals" }, [
              _c("h4", [_vm._v("Per user")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.perUser, function(date) {
                  return _c("li", [
                    _c("span", { staticClass: "user" }, [
                      _vm._v(_vm._s(date.label))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "count" }, [
                      _vm._v(_vm._s(date.count) + " views")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "duration" }, [
                      _vm._v(_vm._s(_vm.formatDuration(date.duration)))
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !(this.videoId * 1)
          ? _c("div", { staticClass: "hl-wid ww4 watch-totals" }, [
              _c("h4", [_vm._v("Per video")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.perVideo, function(date) {
                  return _c("li", [
                    _c("span", { staticClass: "video" }, [
                      _vm._v(_vm._s(date.label))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "count" }, [
                      _vm._v(_vm._s(date.count) + " views")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "duration" }, [
                      _vm._v(_vm._s(_vm.formatDuration(date.duration)))
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }